"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var Text_1 = __importDefault(require("shared/components/Text"));
var DiscountSplitDropdown_1 = __importDefault(require("./DiscountSplitDropdown"));
var DiscountSplitByException = function (_a) {
    var item = _a.item;
    var boxRef = react_1.default.useRef(null);
    var _b = __read(react_1.default.useState(null), 2), isDropdownOpen = _b[0], setDropdownOpen = _b[1];
    var handleDropdownClick = function (e) {
        e.stopPropagation();
        setDropdownOpen(isDropdownOpen ? null : boxRef.current);
    };
    var handleDropdownOnClose = function () { return setDropdownOpen(null); };
    var accFirmMargin = item.totalDiscount * item.discountSplit;
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", alignItems: "center", justifyContent: "flex-end", width: 1, height: 1 }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, textAlign: "right", noWrap: true, mr: 1, width: 52, color: "riverstone" }, { children: (0, end2end_1.formatPercentagePrecise)(accFirmMargin) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ ref: boxRef, flexGrow: 1, display: "flex", pl: 0 }, { children: (0, jsx_runtime_1.jsx)(IconButtons_1.EditButton, { onClick: handleDropdownClick, className: (0, clsx_1.default)('higlightInput', isDropdownOpen ? undefined : 'showOnHover') }) })), isDropdownOpen && (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
            (0, jsx_runtime_1.jsx)("div", __assign({ onClick: function (e) { return e.stopPropagation(); } }, { children: (0, jsx_runtime_1.jsx)(DiscountSplitDropdown_1.default, { onClose: handleDropdownOnClose, isDropdownOpen: isDropdownOpen, item: item }) })))] })));
};
exports.default = DiscountSplitByException;
